var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessBulk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 142,
    viewBox: "0 0 400 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M204.5 135C245.645 135 279 130.299 279 124.5C279 118.701 245.645 114 204.5 114C163.355 114 130 118.701 130 124.5C130 130.299 163.355 135 204.5 135Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113 61L158 61V11L113 11V61Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118 18C119.105 18 120 17.3284 120 16.5C120 15.6716 119.105 15 118 15C116.895 15 116 15.6716 116 16.5C116 17.3284 116.895 18 118 18Z",
    fill: "#FFD200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 18C123.328 18 124 17.3284 124 16.5C124 15.6716 123.328 15 122.5 15C121.672 15 121 15.6716 121 16.5C121 17.3284 121.672 18 122.5 18Z",
    fill: "#0D9F3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.5 18C128.328 18 129 17.3284 129 16.5C129 15.6716 128.328 15 127.5 15C126.672 15 126 15.6716 126 16.5C126 17.3284 126.672 18 127.5 18Z",
    fill: "#24285B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.5 44C140.747 44 145 39.7467 145 34.5C145 29.2533 140.747 25 135.5 25C130.253 25 126 29.2533 126 34.5C126 39.7467 130.253 44 135.5 44Z",
    fill: "#24285B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136 34L145 30.5775C145 30.5775 143.283 25.1869 136.234 25L136 34Z",
    fill: "#FFD200"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136 34.4676L144.284 38C144.751 36.8941 144.994 35.7055 145 34.5036C145.006 33.3016 144.774 32.1106 144.319 31L136 34.4676Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M145 52H126V56H145V52Z",
    fill: "#878787"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M145.881 114.565C145.881 114.565 140.232 113.105 139 108.132C139 108.132 147.751 106.461 148 115L145.881 114.565Z",
    fill: "#0D9F3F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M146.939 113.987C146.939 113.987 142.917 107.791 146.458 102C146.458 102 153.245 106.201 150.226 114L146.939 113.987Z",
    fill: "#0D9F3F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148 113.983C148 113.983 149.958 108.11 155.893 107C155.893 107 157.005 110.813 152.049 114L148 113.983Z",
    fill: "#0D9F3F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144 114L145.091 121.968L151.982 122L153 114.039L144 114Z",
    fill: "#24285B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171 50V117.739C171 122.831 185.775 127 204 127C222.225 127 237 122.856 237 117.739V50H171Z",
    fill: "#0D9F3F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M204 60C222.225 60 237 55.7467 237 50.5C237 45.2533 222.225 41 204 41C185.775 41 171 45.2533 171 50.5C171 55.7467 185.775 60 204 60Z",
    fill: "#0D9F3F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M204 60C222.225 60 237 55.7467 237 50.5C237 45.2533 222.225 41 204 41C185.775 41 171 45.2533 171 50.5C171 55.7467 185.775 60 204 60Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M171 74C171 74 200.825 85.4915 237 74V97.7966C237 97.7966 206.54 111.754 171 97.7966V74Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M287 32H224V66H287V32Z",
    fill: "#24285B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M175 65C175 65 181.335 69.1465 197 68.996",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M175 87C175 87 181.335 91.1521 197 90.9957",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M175 110C175 110 181.335 114.152 197 113.996",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M278.618 51.0073L276.545 49.3612C276.607 48.7847 276.607 48.2028 276.545 47.6262L278.618 45.9739C278.807 45.821 278.936 45.6044 278.982 45.3631C279.027 45.1219 278.987 44.8719 278.867 44.6583L276.707 40.8452C276.585 40.6313 276.393 40.4682 276.165 40.3844C275.936 40.3007 275.686 40.3018 275.458 40.3876L273.017 41.3917C272.557 41.0541 272.065 40.7626 271.55 40.521L271.175 37.8836C271.143 37.6377 271.024 37.4121 270.84 37.2494C270.656 37.0867 270.42 36.9981 270.176 37.0002H265.856C265.61 36.9949 265.371 37.0821 265.184 37.2451C264.997 37.4081 264.876 37.6355 264.844 37.8836L264.463 40.5338C263.95 40.7752 263.46 41.0668 263.002 41.4044L260.548 40.4003C260.322 40.3072 260.07 40.3017 259.84 40.3848C259.61 40.468 259.418 40.634 259.3 40.8515L257.139 44.6647C257.016 44.8788 256.972 45.1311 257.017 45.3752C257.062 45.6192 257.192 45.8386 257.383 45.9929L259.456 47.639C259.393 48.2155 259.393 48.7974 259.456 49.3739L257.383 51.0263C257.195 51.1801 257.067 51.3971 257.022 51.6383C256.978 51.8795 257.019 52.129 257.139 52.3419L259.293 56.155C259.414 56.3698 259.606 56.5338 259.835 56.6176C260.064 56.7015 260.315 56.6997 260.542 56.6126L262.984 55.6085C263.445 55.9447 263.936 56.2362 264.451 56.4791L264.832 59.1166C264.862 59.362 264.98 59.5875 265.163 59.7503C265.346 59.9131 265.581 60.0019 265.824 60H270.145C270.386 60.001 270.619 59.9134 270.801 59.7535C270.984 59.5935 271.103 59.3718 271.138 59.1293L271.519 56.4791C272.032 56.2377 272.522 55.9461 272.98 55.6085L275.433 56.6126C275.66 56.7043 275.911 56.7091 276.141 56.6261C276.371 56.5431 276.563 56.3779 276.682 56.1614L278.843 52.3482C278.97 52.1347 279.018 51.8814 278.977 51.6349C278.935 51.3885 278.808 51.1655 278.618 51.0073ZM268.003 53.2761C267.073 53.2773 266.164 52.9977 265.39 52.4727C264.616 51.9476 264.012 51.2006 263.655 50.3263C263.299 49.452 263.205 48.4896 263.385 47.5609C263.566 46.6321 264.013 45.7788 264.671 45.1089C265.328 44.439 266.166 43.9826 267.078 43.7975C267.99 43.6123 268.936 43.7067 269.795 44.0687C270.654 44.4307 271.389 45.0441 271.906 45.8312C272.423 46.6183 272.699 47.5438 272.699 48.4906C272.699 49.7565 272.206 50.9708 271.328 51.8677C270.451 52.7646 269.26 53.271 268.016 53.2761H268.003Z",
    fill: "#FFD200"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M250 44H232V47H250V44Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M250 51H232V54H250V51Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessBulk);
export default __webpack_public_path__ + "static/media/processBulk.8f33ace6a378852b1a53f95c32d0c1df.svg";
export { ForwardRef as ReactComponent };